/**
 * Cropper组件demo
 * @description 切割图片组件demo
 * @author mll
 * @date 2020-4-16
 */
import React from 'react';
import { connect } from 'dva';
import 'cropperjs/dist/cropper.css'
import { component_tool, framework_tool, utils_tool } from '../../../tool'
let { WizCard, WizUpload, WizRow, WizButton, WizTypography, WizCropper, WizCropperModal } = component_tool;
let { WizContainer,WizOssUpload } = framework_tool;
const { Paragraph, Text, Title } = WizTypography;
let { transformFile } = utils_tool

class Cropper extends WizContainer {

  componentName = 'CropperDemo';

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    }
    log.info('WizCropper:',WizCropper)
    log.info('WizCropperModal:',WizCropperModal)
    
  }

  _crop(e, base64File, file) {
    //log.info('fileData base64:', base64File);
    log.info('fileData file:', file);
  }

  /**
   * 普通裁剪使用方式
   */
  _cropper = () => {
    return (
      <WizCard title='裁剪组件' icon={0}>
        <WizCropper
          fileName={'text.png'}
          cropBoxResizable={false}//是否允许调整裁剪框大小
          ref={'cropper'}
          src='https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2638804118,2479439995&fm=26&gp=0.jpg'
          style={{ height: 200, width: 300 }}
          aspectRatio={16 / 9}//裁剪框比例
          guides={false}
          crop={this._crop.bind(this)}
        />
      </WizCard>
    )
  }

  _beforeUpload = (file) => {
    transformFile.fileToBase64(file, (base64) => {
      this.setState({
        visible: true,
        cropperModal: {
          modalProps: {
            title: '裁剪图片',
            visible: true,
            onOk: (e) => {
              log.info('e:', e)
              this.setState({ visible: false, selectFile: e['base64File'] })
            },
            onCancel: () => { this.setState({ visible: false }) }
          },
          cropperProps: {
            aspectRatio: 1,
            fileName: file['name'],
            style: { height: 400, width: '100%' },
            file: file,
            src: base64,
            cropBoxResizable: false
          }
        }
      })
    })
    return false;
  }

  /**
   * 裁剪Modal使用方式
   */
  _cropperModal = () => {
    let { visible, selectFile, cropperModal } = this.state
    let modal = visible ? <WizCropperModal {...cropperModal} /> : null;
    let img = selectFile ? <img src={selectFile} style={{ width: 9 * 20, height: 9 * 20, marginTop: 20 }} /> : null
    return (
      <WizCard title='裁剪弹框组件' icon={0}>
        <WizRow>
          <WizUpload
            accept={'.jpg, .jpeg, .png'}
            beforeUpload={this._beforeUpload}
            showUploadList={false}
          >
            <WizButton>选择图片</WizButton>
          </WizUpload>
        </WizRow>
        <WizRow>
          {modal}
          {img}
        </WizRow>
      </WizCard>
    )
  }

  _ossBeforeUpload = (file, startUpload, removeFile) => {
    transformFile.fileToBase64(file, (base64) => {
      this.setState({
        visible: true,
        cropperModal: {
          modalProps: {
            title: '裁剪图片',
            visible: true,
            onOk: (e) => {
              this.setState({ visible: false }, () => {
                startUpload && startUpload(e['file'])
              })
            },
            onCancel: () => {
              this.setState({ visible: false }, () => {
                removeFile && removeFile(file)
              })
            }
          },
          cropperProps: {
            aspectRatio: 16 / 9,
            fileName: file['name'],
            style: { height: 400, width: '100%' },
            file: file,
            src: base64,
            cropBoxResizable: false
          }
        }
      })
    })
    return false;
  }

  /**
   * 与 ossupload联动
   */
  _cropperOssUpload = () => {
    return (
      <WizCard title='结合oss上传组件使用' icon={0}>
        <WizOssUpload key={2}
          accept={'.jpg, .jpeg, .png'}
          listType={'picture'}
          beforeUpload={this._ossBeforeUpload}
        />
      </WizCard>
    )
  }

  _info = () => {
    return (
      <WizCard title='介绍' icon={0}>
        <Title level={4}> WizCropper:</Title>
        <Paragraph>
          该组件是基于<a href="https://github.com/roadmanfong/react-cropper" target="_blank" rel="noopener noreferrer">react-cropper</a>进行了二次封装。
        </Paragraph>
        <Paragraph>
          1、优化了cropper的使用方式。
        </Paragraph>
        <Paragraph>
          2、扩充了裁剪图片返回对象的类型，目前返回的类型有：cropper组件截图后返回的对象、base64、File。
        </Paragraph>
        <Paragraph>
          3、对一些参数的默认值进行修改。
        </Paragraph>
        <Title level={4}> WizCropperModal:</Title>
        <Paragraph>
          该组件是为了配合选择文件组件的使用场景进行的封装，将modal和cropper整合成一个组件，调用时关心传参和出参即可。
        </Paragraph>
      </WizCard>
    )
  }

  _render() {
    return (
      <>
        {this._info()}
        {this._cropper()}
        {this._cropperModal()}
        {this._cropperOssUpload()}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {

  };
};

export default connect(mapStateToProps)(Cropper);
